import Menu from './Menu.view';

export default Menu;
